module.exports = __webpack_public_path__ + "img/earth2.cd30a809.png";